export const getDefaultSettings = (type) => {
  return type === 'card' ? table_settings_default : report_table_settings_default;
}

export const getTableHeadings = (type) => {
  return type === 'card' ? table_settings : report_table_settings;
}

export const getTableCell = (type) => {
  return type === 'card' ? table_cell_styles : report_table_cell_styles;
}

const table_settings_default =  {
  cardNumber: true,
  carPlate: true,
  driver: true,
  balance: true,
  lockedItem: true,
  status: true,
  createdAt: false,
  organization: false,
  amount: false,
  currency: false,
  value: false,
}

const report_table_settings_default =  {
  cardNumber: true,
  cardOwner: true,
  carPlate: true,
  driverPhone: true,
  startBalance: true,
  income: false,
  paymentDate: true,
  terminal: true,
  gasStation: false,
  product: false,
  productSize: false,
}

const table_settings = {
  cardNumber: "Картын Дугаар",
  carPlate: "Машины Дугаар",
  driver: "Жолоочийн Нэр",
  balance: "Дансны Үлдэгдэл",
  lockedItem: "Түгжсэн бүтээгдэхүүн",
  status: "Төлөв",
  createdAt: "Үүсгэсэн огноо",
  organization: "Байгууллага",
  amount: "Дүн",
  currency: "Валют",
  value: "Утга",
};

const report_table_settings = {
  cardNumber: "Картын Дугаар",
  cardOwner: "Карт эзэмшигчийн нэр",
  carPlate: "Машины Дугаар",
  driverPhone: "Жолоочийн утас",
  startBalance: "Эхний үлдэгдэл",
  income: "Орлого",
  paymentDate: "Худалдан авалт хийсэн огноо",
  terminal: "Терминал дугаар",
  gasStation: "Худалдан авалт хийсэн ШТС",
  product: "Худалдан авалт хийсэн бүтээгдэхүүн",
  productSize: "Худалдан авалт хийсэн хэмжээ (литр)",
};

const table_cell_styles = {
  cardNumber: {minWidth: '200px', padding: '16px 8px 16px 24px'},
  carPlate: {minWidth: '170px', padding: '16px 8px'},
  driver: {minWidth: '170px', padding: '16px 8px'},
  balance: {minWidth: '180px', padding: '16px 8px'},
  lockedItem: {minWidth: '200px', padding: '16px 8px'},
  status: {minWidth: '140px', padding: '16px 8px'},
  createdAt: {minWidth: '160px', padding: '16px 8px'},
  organization: {minWidth: '0px', padding: '16px 8px'},
  amount: {minWidth: '0px', padding: '16px 8px'},
  currency: {minWidth: '0px', padding: '16px 8px'},
  value: {minWidth: '0px', padding: '16px 8px'},
};

const report_table_cell_styles = {
  cardNumber: {minWidth: '200px', padding: '16px 8px 16px 24px'},
  cardOwner: {minWidth: '170px', padding: '16px 8px'},
  carPlate: {minWidth: '170px', padding: '16px 8px'},
  driverPhone: {minWidth: '170px', padding: '16px 8px'},
  startBalance: {minWidth: '180px', padding: '16px 8px'},
  income: {minWidth: '180px', padding: '16px 8px'},
  paymentDate: {minWidth: '160px', padding: '16px 8px'},
  terminal: {minWidth: '160px', padding: '16px 8px'},
  gasStation: {minWidth: '150px', padding: '16px 8px'},
  product: {minWidth: '150px', padding: '16px 8px'},
  productSize: {minWidth: '200px', padding: '16px 8px'},
};

export const cards_data = [
  {
    cardNumber: "4902 4900 5188 4344",
    carPlate: "",
    driver: "",
    balance: null,
    lockedItem: "",
    status: "",
    createdAt: "",
    organization: "",
    amount: "",
    currency: "MNT",
    value: "",
  },
  {
    cardNumber: "4210 446 8523 3224",
    carPlate: "3311 УБХ",
    driver: "Б. Болдсайхан",
    balance: 129090876,
    lockedItem: "АИ-92",
    status: "active",
    createdAt: "",
    organization: "",
    amount: "",
    currency: "MNT",
    value: "",
  },
  {
    cardNumber: "4231 7644 7465 0932",
    carPlate: "2873 УЖӨ",
    driver: "Б. Дөлгөөн",
    balance: 897989999,
    lockedItem: "АИ-95",
    status: "active",
    createdAt: "",
    organization: "",
    amount: "",
    currency: "MNT",
    value: "",
  },
  {
    cardNumber: "4132 7645 0923 8759",
    carPlate: "8576 УНА",
    driver: "Г.Мишээл",
    balance: 900000,
    lockedItem: "АИ-98",
    status: "active",
    createdAt: "",
    organization: "",
    amount: "",
    currency: "MNT",
    value: "",
  },
  {
    cardNumber: "4000 7647 8321 4959",
    carPlate: "9999 УАА",
    driver: "Э.Цогт",
    balance: 350000000,
    lockedItem: "ДТ",
    status: "inactive",
    createdAt: "",
    organization: "",
    amount: "",
    currency: "MNT",
    value: "",
  },
  {
    cardNumber: "4975 6236 0939 6465",
    carPlate: "0001 УНЭ",
    driver: "Б.Тайванбат",
    balance: 200000,
    lockedItem: "ДТ",
    status: "inactive",
    createdAt: "",
    organization: "",
    amount: "",
    currency: "MNT",
    value: "",
  },
];

export const report_data = [
  {
    cardNumber: "4902 4900 5188 4344",
    cardOwner: "Болд",
    carPlate: "",
    driverPhone: "9191-9191",
    startBalance: "50,000₮",
    income: "",
    paymentDate: "2022.07.01 11:05",
    terminal: "5031567541",
    gasStation: "",
    product: "",
    productSize: "",
  },
  {
    cardNumber: "4210 446 8523 3224",
    cardOwner: "Болд",
    carPlate: "3311 УБХ",
    driverPhone: "9191-9191",
    startBalance: "50,000₮",
    income: "",
    paymentDate: "2022.07.01 11:05",
    terminal: "5031567541",
    gasStation: "",
    product: "",
    productSize: "",
  },
  {
    cardNumber: "4231 7644 7465 0932",
    cardOwner: "Болд",
    carPlate: "2873 УЖӨ",
    driverPhone: "9191-9191",
    startBalance: "50,000₮",
    income: "",
    paymentDate: "2022.07.01 11:05",
    terminal: "5031567541",
    gasStation: "",
    product: "",
    productSize: "",
  },
  {
    cardNumber: "4132 7645 0923 8759",
    cardOwner: "Болд",
    carPlate: "8576 УНА",
    driverPhone: "9191-9191",
    startBalance: "50,000₮",
    income: "",
    paymentDate: "2022.07.01 11:05",
    terminal: "5031567541",
    gasStation: "",
    product: "",
    productSize: "",
  },
  {
    cardNumber: "4000 7647 8321 4959",
    cardOwner: "Болд",
    carPlate: "9999 УАА",
    driverPhone: "9191-9191",
    startBalance: "50,000₮",
    income: "",
    paymentDate: "2022.07.01 11:05",
    terminal: "5031567541",
    gasStation: "",
    product: "",
    productSize: "",
  },
  {
    cardNumber: "4975 6236 0939 6465",
    cardOwner: "Болд",
    carPlate: "0001 УНЭ",
    driverPhone: "9191-9191",
    startBalance: "50,000₮",
    income: "",
    paymentDate: "2022.07.01 11:05",
    terminal: "5031567541",
    gasStation: "",
    product: "",
    productSize: "",
  },
]
